export const TranslationIdMap = '';

export const TranslationKeyMap = {
    '_710_SEARCH': 'Search',
    '_7360_FILTER': 'Filter',
    '_127_STATUS': 'Status',
    '_709_DATE_RANGE': 'Date Range',
    '_9468_SORT': 'Sort',
    '_7216_SORT_BY': 'Sort by',
    '__DATE_NEWEST_FIRST': 'Date: Newest First',
    '__DATE_OLDEST_FIRST': 'Date: Oldest First',
    '__USER_NAME_ASCENDING': 'User Name: Ascending',
    '__USER_NAME_DESCENDING': 'User Name: Descending'
};
